"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dot = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const blockClass = (0, nano_theme_1.drule)({
    d: 'inline-block',
    bdrad: '50%',
    flex: '0 0 auto',
});
const isSemantic = (color) => color === 'neutral' ||
    color === 'success' ||
    color === 'error' ||
    color === 'warning' ||
    color === 'link' ||
    color === 'accent';
const resolveColor = (styles, color) => {
    if (isSemantic(color)) {
        if (color === 'neutral')
            return styles.g(0.5);
        return styles.col.get(color, 'solid-1');
    }
    return color;
};
const Dot = ({ color = 'neutral', size = 8, glow, className, style }) => {
    const styles = (0, context_1.useStyles)();
    const resolved = resolveColor(styles, color);
    return (React.createElement("span", { className: blockClass({
            bg: resolved,
            bxsh: glow ? `0 0 0 3px ${resolved}33` : undefined,
        }) + (className ? ` ${className}` : ''), style: { width: size, height: size, ...style } }));
};
exports.Dot = Dot;
